export interface AuthUser {
  uid: string;
  email?: string | null;
  photoURL?: string;
  // displayName?: string;
  isAdmin?: boolean;
}

export interface UserDetail {
  uuid: string;
  email?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  lastlogin?: string | null;
  role?: string | null;
  photoURL?: string;
}
